var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"acs-container"},[_c('h1',{staticClass:"page-title"},[_vm._v("Insights")]),_c('ErrorBanner'),(_vm.isLoading)?_c('loading-icon'):_vm._e(),_c('div',{attrs:{"id":"quicksight-container"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }